import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {AgendaToolbarMyAgendaTitle} from '@/features/agenda/components/agenda-toolbar-title/AgendaToolbarMyAgendaTitle'
import {AgendaToolbarSubjectTitle} from '@/features/agenda/components/agenda-toolbar-title/AgendaToolbarSubjectTitle'
import {AgendaToolbarTeamTitle} from '@/features/agenda/components/agenda-toolbar-title/AgendaToobarTeamTitle'
import {AgendaToolbarPatientAgeRangeTitle} from '@/features/agenda/components/agenda-toolbar-title/AgendaToolbarPatientAgeRangeTitle'

export const AgendaToolbarTitle = () => {
    const {
        searchParams: {category, subjectIds, patientId, specializationIds},
        isTeamCategory,
        isPatientAgeRangeCategory
    } = useAgendaSearchParams()

    const {
        params: {entity}
    } = useAgendaNavigation()

    const hasNoFilters = !patientId && !specializationIds?.length && !subjectIds?.length
    const shouldShowMyAgenda = !category || (category && hasNoFilters)
    const hasSingleSubject = entity && subjectIds?.length === 1

    if (shouldShowMyAgenda) {
        return <AgendaToolbarMyAgendaTitle />
    }

    if (isTeamCategory) {
        return <AgendaToolbarTeamTitle />
    }

    if (isPatientAgeRangeCategory) {
        return <AgendaToolbarPatientAgeRangeTitle />
    }

    if (hasSingleSubject) {
        return <AgendaToolbarSubjectTitle id={subjectIds[0]} entity={entity} />
    }

    return <div />
}
